module.exports = __webpack_public_path__ + "img/facebook copy.05d408e6.svg";